import { Fragment } from 'react';
import { Helmet } from 'react-helmet-async';

interface AnalyticsScriptsProps {
  gtmId?: string;
  hubspotId?: string;
  cookieyesId?: string;
}

export function AnalyticsHeadScripts({
  gtmId,
  hubspotId,
  cookieyesId
}: AnalyticsScriptsProps) {
  return (
    <Fragment>
      {/* Google Tag Manager */}
      {gtmId && (
        <script
          dangerouslySetInnerHTML={{
            __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');`
          }}
        />
      )}

      {/* HubSpot Script */}
      {hubspotId && (
        <script
          type='text/javascript'
          id='hs-script-loader'
          async
          defer
          src={`https://js-eu1.hs-scripts.com/${hubspotId}.js`}
        />
      )}

      {/* Cookieyes Banner */}
      {cookieyesId && (
        <script
          id='cookieyes'
          type='text/javascript'
          src={`https://cdn-cookieyes.com/client_data/${cookieyesId}/script.js`}
        />
      )}
    </Fragment>
  );
}

export function AnalyticsBodyScripts({
  gtmId
}: Pick<AnalyticsScriptsProps, 'gtmId'>) {
  return (
    <Fragment>
      {/* Google Tag Manager (noscript) */}
      {gtmId && (
        <noscript>
          <iframe
            src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
            height='0'
            width='0'
            style={{ display: 'none', visibility: 'hidden' }}
          />
        </noscript>
      )}
    </Fragment>
  );
}

export function AnalyticsHelmetScripts({
  gtmId,
  hubspotId
}: Pick<AnalyticsScriptsProps, 'gtmId' | 'hubspotId'>) {
  return (
    <>
      <Helmet>
        {/* Google Tag Manager */}
        {gtmId && (
          <script type='text/javascript'>
            {`
							(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
							new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
							j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
							'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
							})(window,document,'script','dataLayer','${gtmId}');
						`}
          </script>
        )}

        {/* HubSpot Script */}
        {hubspotId && (
          <script
            type='text/javascript'
            id='hs-script-loader'
            async
            defer
            src={`https://js-eu1.hs-scripts.com/${hubspotId}.js`}
          />
        )}
      </Helmet>

      {/* Google Tag Manager (noscript) */}
      {gtmId && (
        <noscript>
          <iframe
            src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
            height='0'
            width='0'
            style={{ display: 'none', visibility: 'hidden' }}
          />
        </noscript>
      )}
    </>
  );
}
